"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapFeatureInfo = void 0;
var ste_simple_events_1 = require("ste-simple-events");
var Select_1 = require("ol/interaction/Select");
var Style_1 = require("ol/style/Style");
var WMSGetFeatureInfo_1 = require("ol/format/WMSGetFeatureInfo");
var olExtent = require("ol/extent");
var Stroke_1 = require("ol/style/Stroke");
var Circle_1 = require("ol/style/Circle");
var Fill_1 = require("ol/style/Fill");
var MapFeatureInfo = /** @class */ (function () {
    function MapFeatureInfo(map, recordTypeResource, _textPack, wmsGetFeatureInfoText, wmsGetFeatureInfoFeatures, elementId) {
        var _this = this;
        if (wmsGetFeatureInfoText === void 0) { wmsGetFeatureInfoText = null; }
        if (wmsGetFeatureInfoFeatures === void 0) { wmsGetFeatureInfoFeatures = null; }
        if (elementId === void 0) { elementId = "placeholder-featureInfo"; }
        this.map = map;
        this.recordTypeResource = recordTypeResource;
        this._textPack = _textPack;
        this.wmsGetFeatureInfoText = wmsGetFeatureInfoText;
        this.wmsGetFeatureInfoFeatures = wmsGetFeatureInfoFeatures;
        this.elementId = elementId;
        this.initialised = false;
        this.selectedFeature = null;
        this._onFeaturesSelected = new ste_simple_events_1.SimpleEventDispatcher();
        this.init = function () {
            if (!_this.initialised) {
                _this.featureInfoElement = $("<div id='featureInfo'></div>").appendTo($("#" + _this.elementId));
                _this.addControls();
                _this.addFeatureInfoPlaceholders();
                _this.addSelectFeatures();
                _this.addWmsGetFeatureInfoHandler();
                _this.map.onLayerVisibilityChanged.subscribe(_this.onOverlayChanged);
                _this.initialised = true;
            }
        };
        this.addControls = function () {
            //add clear selection link & help text
            _this.clearButton = $("<button id=\"clearFeatureInfo\" class=\"clearFeatureInfo btn btn-primary btn-sm mb-2\">" + _this._textPack.clearSelection + "</button>");
            _this.featureInfoElement.append(_this.clearButton);
            _this.clearButton.hide();
            _this.pleaseSelectDiv = $("<div id=\"helpFeatureInfo\" class=\"helpFeatureInfo\">" + _this._textPack.clickOnMapToSelectFeature + "</div>");
            _this.featureInfoElement.append(_this.pleaseSelectDiv);
        };
        this.addFeatureInfoPlaceholders = function () {
            //add a placeholder for each queryable layer (in order)
            var self = _this;
            var layerGroupCollection = self.map.options.layerGroupCollection;
            var allLayers = layerGroupCollection.allLayers;
            allLayers.forEach(function (l) {
                if (layerGroupCollection.isVectorLayerGroup(l)) {
                    self.featureInfoElement.append("<div id=\"wfsFeatureInfo_" + l.ref + "\" class=\"wfsFeatureInfo\"></div>");
                }
                else {
                    self.featureInfoElement.append("<div id=\"wmsFeatureInfo_" + l.ref + "\" class=\"wmsFeatureInfo\"></div>");
                }
            });
        };
        this.onOverlayChanged = function (args) {
            var self = _this;
            if (args.visible === false) {
                //remove any selected features that are of the same recordtype as the layer being hidden
                var featuresToRemove_1 = [];
                self.selectFeatures.getFeatures().forEach(function (feature) {
                    if (feature && feature.getProperties()["rectype"] === args.recordType) {
                        featuresToRemove_1.push(feature);
                    }
                });
                featuresToRemove_1.forEach(function (feature) {
                    self.selectFeatures.getFeatures().remove(feature);
                });
                //now clear the feature info
                //wfs & cluster
                $("#wfsFeatureInfo_" + args.layerGroupRef).empty();
                //for wms
                $("#wmsFeatureInfo_" + args.layerGroupRef).empty();
                //if the last wfs is turned off && we have wms features then we need to hide the clear btn and show the text
                if (self.selectFeatures.getFeatures().getLength() === 0 && $(".wmsFeatureInfo h4").length === 0) {
                    self.pleaseSelectDiv.show();
                    self.clearButton.hide();
                }
            }
        };
        //$("#mapLoader").show();
        this.fetchingWmsFeatureInfo = function () {
            _this.loadingCount += 1;
            $("#mapLoader").show();
        };
        this.wmsFeatureInfoComplete = function () {
            _this.loadingCount -= 1;
            if (_this.loadingCount === 0) {
                $("#mapLoader").hide();
            }
        };
        this.addWmsGetFeatureInfoHandler = function () {
            var self = _this;
            self.map.olMap.on('singleclick', function (evt) {
                var viewResolution = self.map.olMap.getView().getResolution();
                var layerSource;
                var wmsLayerGroups = self.map.options.layerGroupCollection.wmsLayerGroups;
                self.loadingCount = 0;
                $("#mapLoader").hide();
                var _loop_1 = function (lyrGrp) {
                    //define this here otherwise info clicka get the last layer name, cos of the setTimeout for the ajax call
                    var localUrl;
                    //clear each layers info click div
                    //do this whether visible or not as user might have turned layer off
                    $("#wmsFeatureInfo_" + lyrGrp.ref).empty();
                    //issue one query per layer group
                    var queryLayers = lyrGrp.queryableLayers;
                    if (queryLayers.length > 0) {
                        layerSource = lyrGrp.layers[0].olWmsLayer.getSource();
                        localUrl = layerSource.getFeatureInfoUrl(evt.coordinate, viewResolution, self.map.options.displayProjection, {
                            'INFO_FORMAT': lyrGrp.info_format,
                            'LAYERS': queryLayers.map(function (f) { return f.layerName; }).join(","),
                            'FEATURE_COUNT': 30
                        });
                        self.fetchingWmsFeatureInfo();
                        //had to put this in a timeout otherwise the maploader wasn't showing
                        //possibly not executing until the thread finished, which by then would have included the ajax success?
                        setTimeout(function () {
                            try {
                                $.ajax({
                                    url: localUrl,
                                    type: 'GET',
                                    async: false,
                                    success: function (response) {
                                        if (lyrGrp.info_format.toLowerCase().indexOf("text") > -1) {
                                            self.processWmsGetFeatureInfoText(lyrGrp, response);
                                        }
                                        else {
                                            var features = new WMSGetFeatureInfo_1.default().readFeatures(response);
                                            self.processWmsGetFeatureInfoFeatures(lyrGrp, features);
                                        }
                                        //expand the info panel if it's not already visible, code smell?
                                        if (!$("#slide-panel-info").is(':visible')) {
                                            $("#slide-panel-btn-info").click();
                                        }
                                        self.wmsFeatureInfoComplete();
                                    }
                                }).fail(function () {
                                    self.wmsFeatureInfoComplete();
                                    console.error("error: " + localUrl);
                                });
                            }
                            catch (_a) {
                                self.wmsFeatureInfoComplete();
                            }
                        }, 10);
                    }
                };
                for (var _i = 0, wmsLayerGroups_1 = wmsLayerGroups; _i < wmsLayerGroups_1.length; _i++) {
                    var lyrGrp = wmsLayerGroups_1[_i];
                    _loop_1(lyrGrp);
                }
            });
        };
        this.processWmsGetFeatureInfoText = function (layerGroup, wmsHtml) {
            var placeholder = $("#wmsFeatureInfo_" + layerGroup.ref);
            if (_this.wmsGetFeatureInfoText != null) {
                _this.wmsGetFeatureInfoText.processWmsGetFeatureInfoText(layerGroup, wmsHtml, placeholder);
            }
            else {
                if (wmsHtml) {
                    var html = "<h4>" + layerGroup.displayName + "</h4>\n                                   <div class=\"wmsFeatureInfoContent\">" + wmsHtml + "</div>";
                    placeholder.append(html);
                }
            }
        };
        this.processWmsGetFeatureInfoFeatures = function (layerGroup, features) {
            var self = _this;
            var placeholder = $("#wmsFeatureInfo_" + layerGroup.ref);
            //keep track of the features
            self.wmsFeatures = {};
            if (self.wmsGetFeatureInfoFeatures != null) {
                self.wmsGetFeatureInfoFeatures.processWmsGetFeatureInfoFeatures(layerGroup, features, placeholder);
            }
            else {
                if (features.length > 0) {
                    var info_columns_to_show_1 = layerGroup.info_columns_to_show.map(function (value) {
                        return value.toUpperCase();
                    });
                    var html_1 = "<h4>" + layerGroup.displayName + "</h4>\n                                    <div class=\"wmsFeatureInfoContent\">\n                                    <dl>";
                    features.forEach(function (f) {
                        var count = 0;
                        var prop = f.getProperties();
                        var featureId = f.getId() || f["ol_uid"];
                        if (featureId) {
                            self.wmsFeatures[featureId] = f;
                        }
                        for (var p in prop) {
                            if (info_columns_to_show_1.length === 0 || info_columns_to_show_1.indexOf(p.toUpperCase()) > -1) {
                                html_1 += "<dt>" + p + "</dt>\n                                     <dd>" + prop[p];
                                if (count === 0 && featureId) {
                                    html_1 += "<a class=\"centreOnMap\" title=\"" + _this._textPack.centreOnMap + "\" data-id=\"" + featureId + "\">\n                                         <i class=\"far fa-map-marked-alt fa-lg\" aria-hidden=\"true\"> </i>\n                                       </a>";
                                }
                                html_1 += '</dd>';
                                count++;
                            }
                        }
                    });
                    html_1 += "</dl></div>";
                    placeholder.append(html_1);
                    //add handlers
                    $(".centreOnMap").on("click", function () {
                        self.centerMapOnWmsFeature($(this).data("id"));
                    });
                }
            }
        };
        this.centerMapOnWmsFeature = function (featureId) {
            var self = _this;
            //find the feature by its id and zoom to its extent
            var f = self.wmsFeatures[featureId];
            if (f) {
                var extent = void 0;
                //lets see if we have a geom, if not see if we have a boundedby value
                //complicated by different versions of gml supporting different features                    
                if (typeof f.getGeometry() !== "undefined") {
                    extent = f.getGeometry().getExtent();
                }
                else {
                    extent = f.get("boundedBy");
                }
                if (typeof extent !== "undefined" && extent && !olExtent.isEmpty(extent) && extent[0] !== Infinity) {
                    self.map.olMap.getView().fit(extent, { duration: 1000, nearest: true });
                }
            }
        };
        this.addSelectFeatures = function () {
            _this.selectFeatures = new Select_1.default({
                filter: _this.canSelectFeature,
                multi: true,
                style: new Style_1.default({
                    fill: new Fill_1.default({
                        color: 'rgba(63, 211, 0, 0.6)'
                    }),
                    stroke: new Stroke_1.default({
                        color: 'rgba(75, 190, 2, 0.8)',
                        width: 5
                    }),
                    image: new Circle_1.default({
                        radius: 12,
                        fill: new Fill_1.default({
                            color: 'rgba(63, 211, 0, 0.6)'
                        }),
                        stroke: new Stroke_1.default({
                            color: 'rgba(75, 190, 2, 0.8)',
                            width: 5
                        })
                    })
                })
            });
            _this.selectFeatures.on('select', function (obj) {
                //e.selected is sometimes empty even though a feature has been visibily selected on the map
                //getFeatures() seems to more reliable
                _this.onFeaturesSelectedInternal(obj.target.getFeatures().getArray(), obj.mapBrowserEvent.coordinate);
            });
            _this.map.olMap.addInteraction(_this.selectFeatures);
        };
        this.canSelectFeature = function (feature, layer) {
            var queryable = layer.get("queryable");
            return (queryable === null || queryable === true);
        };
        this.onFeaturesSelectedInternal = function (featuresArray, coordinate) {
            var self = _this, uids = {}, features, previousType = "", html = "";
            features = featuresArray;
            var vectorLayerGroups = self.map.options.layerGroupCollection.vectorLayerGroups;
            for (var _i = 0, vectorLayerGroups_1 = vectorLayerGroups; _i < vectorLayerGroups_1.length; _i++) {
                var lyrGrp = vectorLayerGroups_1[_i];
                //clear each layers info click div
                //do this whether visible or not as user might have turned layer off
                $("#wfsFeatureInfo_" + lyrGrp.ref).empty();
            }
            if (features && features.length > 0) {
                var selectedFeatures_1 = new Array();
                //create a lookup of rectype/position for sorting the array correctly
                var layerOrder_1 = {};
                for (var i = 0; i < _this.map.options.layerGroupCollection.vectorLayerGroups.length; i++) {
                    layerOrder_1[_this.map.options.layerGroupCollection.vectorLayerGroups[i].layerType] = i;
                }
                //group the features by layer type and in the order that the layers appear on the map
                //get the features into an array order by record type & name
                //problem with long strings or content thereof not sorting, but sorting works fine if we just use the first 20 chars
                var sortedFeatures = features.sort(function (a, b) {
                    var aProp = a.getProperties();
                    var bProp = b.getProperties();
                    var recTypeA = (layerOrder_1[aProp["rectype"] || ""] + (aProp["recsubtype"] || "") + (aProp["name"] || "").substring(0, 20)).toUpperCase();
                    var recTypeB = (layerOrder_1[bProp["rectype"] || ""] + (bProp["recsubtype"] || "") + (bProp["name"] || "").substring(0, 20)).toUpperCase();
                    return (recTypeA < recTypeB) ? -1 : (recTypeA > recTypeB) ? 1 : 0;
                });
                //group the features by record type and subtype
                var layerGroupMap_1 = new Map();
                //group the features by type/subtype
                var groupFeature = function (f) {
                    //get layer doesn't seem to work for cluster layers
                    var layer = self.selectFeatures.getLayer(f);
                    var layerGroup = null;
                    if (layer) {
                        layerGroup = layer.get("layerGroup");
                    }
                    else {
                        //see f its on the feature
                        layerGroup = f.get("layerGroup");
                    }
                    var feature = self.recordTypeResource.mapToIRecordTypeInfoClick(f.getProperties(), layerGroup);
                    feature.id = f.getId();
                    feature.data.id = f.getId();
                    if (feature.uid && !uids[feature.uid]) {
                        //stop duplicates                  
                        uids[feature.uid] = 1;
                        selectedFeatures_1.push(f);
                        //if not already set the set data.rectype
                        if (!f.getProperties()["rectype"]) {
                            f.setProperties({ rectype: feature.recordType }, true);
                        }
                        //use the record type from the layer group not the feature itself
                        //as we might need to distinguish between, for example, different layers of the same type: mysites/sites/uig/allsites
                        //if no layer group that use the rectype
                        var currentType = (feature.layerGroup) ? feature.layerGroup.layerType + (feature.layerGroup.layerSubType || "") : feature.recordType + (feature.recordSubType || "");
                        if (previousType !== currentType) {
                            layerGroupMap_1.set(currentType, new Array());
                            previousType = currentType;
                        }
                        layerGroupMap_1.get(currentType).push(feature);
                    }
                };
                for (var i = 0; i < sortedFeatures.length; i++) {
                    var clusterFeatures = sortedFeatures[i].get("features");
                    if (typeof clusterFeatures !== "undefined") {
                        var f = void 0;
                        for (var i_1 = 0; i_1 < clusterFeatures.length; i_1++) {
                            f = clusterFeatures[i_1];
                            groupFeature(f);
                        }
                        //cluster                    
                        //set rectype on the cluster feature                    
                        sortedFeatures[i].setProperties({ rectype: f.getProperties()["rectype"] }, true);
                    }
                    else {
                        groupFeature(sortedFeatures[i]);
                    }
                }
                _this.createFeatureListHtml(layerGroupMap_1);
                $(".clearFeatureInfo").on("click", function () {
                    self.clear();
                });
                $(".showOnMap").on("click", function () {
                    var id = $(this).data("id");
                    self.moveMapToFeature(id);
                });
                //expand the info panel if it's not already visible, code smell?
                if (!$("#slide-panel-info").is(':visible')) {
                    $("#slide-panel-btn-info").click();
                }
                self._onFeaturesSelected.dispatch({ features: selectedFeatures_1 });
                self.pleaseSelectDiv.hide();
                self.clearButton.show();
            }
            else {
                //log("no features selected");
                self.pleaseSelectDiv.show();
                self.clearButton.hide();
            }
        };
        this.createFeatureListHtml = function (layerGroupMap) {
            var html = "";
            layerGroupMap.forEach(function (value, key) {
                //console.log(value, key);
                var features = value;
                html = "<h4>" + features[0].heading + "</h4>";
                html += "<ul class=\"featureInfoList\">";
                features.forEach(function (feature) {
                    html += _this.recordTypeResource.getInfoClickHtmlTemplate(feature);
                    feature.data.css = "popupRecord";
                    html = _this.replaceTokens(html, feature.data);
                });
                html += '</ul>';
                html += '<hr/>';
                $("#wfsFeatureInfo_" + features[0].layerGroup.ref).append(html);
            });
        };
        this.clear = function () {
            _this.selectFeatures.getFeatures().clear();
            //now clear the html
            _this.featureInfoElement.html("");
            //rebuild the controls & placeholders
            _this.addControls();
            _this.addFeatureInfoPlaceholders();
            _this.pleaseSelectDiv.show();
            _this.clearButton.hide();
        };
        //private centerMap = (x:number, y:number): void => {
        //    let extent = feature.getGeometry().getExtent();
        //    //var centre = olExtent.getCenter(extent);
        //    //this.map.olMap.getView().animate({ center: centre });
        //    this.map.olMap.getView().fit(extent, { duration: 1000 });
        //}
        this.moveMapToFeature = function (id) {
            var feature = null;
            var find = function () {
                for (var _i = 0, _a = _this.map.options.layerGroupCollection.vectorLayerGroups; _i < _a.length; _i++) {
                    var lg = _a[_i];
                    //  if (lg.visible(this.mapStore) === true) {
                    for (var _b = 0, _c = lg.layers; _b < _c.length; _b++) {
                        var l = _c[_b];
                        //if (l.visible === true) {
                        var f = l.olVectorLayer.getSource().getFeatureById(id);
                        if (f !== null) {
                            return f;
                        }
                        // }
                    }
                    // }            
                }
                return null;
            };
            feature = find();
            if (feature !== null) {
                //if (this.selectedFeature !== null) {
                //    //reset style
                //    this.selectedFeature.setStyle(this.selectedFeatureOrigStyle);
                //    this.selectedFeatureOrigStyle = feature.getStyle();
                //}
                //feature.setStyle(this._styleFactory.getSelectedStyle(null));
                //this.selectedFeature = feature;
                var extent = feature.getGeometry().getExtent();
                //var centre = olExtent.getCenter(extent);
                //this.map.olMap.getView().animate({ center: centre });
                _this.map.olMap.getView().fit(extent, { duration: 1000 });
            }
        };
        this.replaceTokens = function (html, data) {
            var val = html;
            //go thru html string and replace any tokens with attribute values
            for (var attributeName in data) {
                if (data.hasOwnProperty(attributeName)) {
                    val = val.replace(new RegExp("\\[" + attributeName + "\\]", "g"), data[attributeName]);
                }
            }
            return val;
        };
        this.init();
    }
    Object.defineProperty(MapFeatureInfo.prototype, "onFeaturesSelected", {
        get: function () {
            return this._onFeaturesSelected.asEvent();
        },
        enumerable: false,
        configurable: true
    });
    return MapFeatureInfo;
}());
exports.MapFeatureInfo = MapFeatureInfo;
//# sourceMappingURL=MapFeatureInfo.js.map